import moment from "moment";
import { BaseModel } from "sjs-base-model";
import configuration from "../../utilities/configuration";
import OrderModel from "../../models/order/OrderModel";
import * as EffectUtility from "../../utilities/EffectUtility";
import localStorage from "../../utilities/localStorage";
import BackendAcceptsPaymentModel from "../../models/basket/BackendAcceptsPaymentModel";
import { recalculateModulePrices } from "../../utilities/modulePricingUtils";

const LOCALSTORAGE_BASKET_KEY = "basket";
const UTC_TIMEFORMAT = "YYYY-MM-DDTHH:mm:ss[Z]";

export async function requestBasket(user) {
    if (user) {
        const endpoint = configuration.apiServer + configuration.apiBasketPath + "/" + user;
        return EffectUtility.getToModel(OrderModel, endpoint);
    } else {
        return localStorage.getJsonItem(LOCALSTORAGE_BASKET_KEY, {});
    }
}

export async function addItem(user, orderItem) {
    const endpoint = configuration.apiServer + configuration.apiBasketPath + "/" + user;
    return EffectUtility.postToModel(BaseModel, endpoint, orderItem, true, true);
}

function calculateTotalPrice(items, vat) {
    const itemsPrice = items.reduce((accumulator, currentValue) => accumulator + currentValue.price, 0);
    const vatValue = (itemsPrice * vat) / 100;
    const totalPrice = itemsPrice + vatValue;
    return totalPrice;
}

function createEmptyBasket() {
    return {
        ...localStorage.getJsonItem(LOCALSTORAGE_BASKET_KEY, {
            items: [],
            updated: moment().format(UTC_TIMEFORMAT)
        })
    };
}

export async function addItemToLocalStorage(orderItem, vat) {
    let basketFromLs = createEmptyBasket();
    let items = [...basketFromLs.items, orderItem];
    items = recalculateModulePrices(items);
    const totalPrice = calculateTotalPrice(items, vat);
    basketFromLs = {
        ...basketFromLs,
        items: items,
        totalPrice: totalPrice,
        vat: vat
    };
    localStorage.setJsonItem(LOCALSTORAGE_BASKET_KEY, basketFromLs);
    return basketFromLs;
}

export async function deleteItem(user, itemId) {
    const endpoint = configuration.apiServer + configuration.apiBasketPath + "/" + user + "/" + itemId;
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}

export async function deleteItemFromLocalStorage(itemId, vat) {
    let basketFromLs = createEmptyBasket();
    let items = basketFromLs.items.filter(item => item.id !== itemId);
    items = recalculateModulePrices(items);
    const totalPrice = calculateTotalPrice(items, vat);
    basketFromLs = {
        ...basketFromLs,
        items: items,
        totalPrice: totalPrice,
        vat: vat
    };
    localStorage.setJsonItem(LOCALSTORAGE_BASKET_KEY, basketFromLs);
    return basketFromLs;
}

export async function deleteAll(user) {
    const endpoint = configuration.apiServer + configuration.apiBasketPath + "/" + user;
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}

export async function deleteAllFromLocalStorage() {
    let basketFromLs = createEmptyBasket();
    basketFromLs = {
        ...basketFromLs,
        items: [],
        totalPrice: 0,
        vat: 0
    };
    localStorage.setJsonItem(LOCALSTORAGE_BASKET_KEY, basketFromLs);
    return basketFromLs;
}

export async function checkOut(user, params) {
    const endpoint = configuration.apiServer + configuration.apiBasketPath + "/" + user + "/checkout";
    return EffectUtility.postToModel(BaseModel, endpoint, params, true, true);
}

export async function addItemsFromLocalStorageToDatabase(user) {
    const basketItemsFromLs = localStorage.getJsonItem(LOCALSTORAGE_BASKET_KEY, null);
    localStorage.removeItem(LOCALSTORAGE_BASKET_KEY);
    if (basketItemsFromLs) {
        basketItemsFromLs.items.forEach(item => {
            delete item.id; // otherwise adding doesn't work
            addItem(user, item);
        });
    }
}

export async function addAdditionalInfo(userId, params) {
    const endpoint = configuration.apiServer + configuration.apiBasketPath + "/" + userId + "/additionalInfo";
    return EffectUtility.putToModel(BackendAcceptsPaymentModel, endpoint, params);
}
